import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import config from 'lib/config';

const axiosInstance = axios.create({
  baseURL:
    process.env.REACT_APP_ENV === 'prod'
      ? config.prodBaseURL
      : process.env.REACT_APP_ENV === 'stag'
      ? config.stagBaseURL
      : config.baseURL,
  timeout: 15000,
});

const responseBody = (response: AxiosResponse) => {
  const { data, ctrl } = response.data;
  // if there is a standard error message, throw it
  if (ctrl?.error_message) throw new Error(ctrl.error_message);
  // if there is data, return it
  if (data) return data;
  // all else, throw error (possibly SQL or backend syntax error)
  throw new Error(`Api call failed. Please contact Focus 360 with the current URL.`);
};

const API = {
  get: (url: string, config?: AxiosRequestConfig) =>
    axiosInstance.get(url, config).then(responseBody),
  post: (url: string, data: any, config?: AxiosRequestConfig) =>
    axiosInstance.post(url, data, config).then(responseBody),
};

export default API;
